import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Col } from 'react-grid-system';
import entities from 'entities';
import Label from '../../../components/shared/Label';
import * as types from '../../../constants';
import { SquadWidgetWrapper, RowWrapper, HeaderWrapper } from './styles';
import TeamLabel from '../../../components/shared/TeamLabel';
import { cleanPlayerName } from '../../../utils/cleanString';
import ConfigManager from '../../../common/configManager/configManager';

const playersURL = ConfigManager.getFootballPlayers();

class SquadWidgetGazzanet extends Component {
  static childContextTypes = {
    breakpoints: PropTypes.arrayOf(PropTypes.number),
  };

  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
    };
  }

  getChildContext = () => ({
    breakpoints: [320, 600, 1024, 1440],
  });

  componentDidMount() {
    window.addEventListener('resize', this.resizeCallback);
    const {
      sportId, teamId, competitionId, actions, widgetId,
    } = this.props;
    actions.getLineup(sportId, teamId, competitionId, widgetId);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeCallback);
  }

  resizeCallback = () => {
    this.setState({
      isMobile: window.innerWidth <= 1023,
    });
  };

  renderPlayerPic = (name, birthDate) => {
    const formattedDate = birthDate.replace(/-/g, '');
    let formattedPlayer = entities.decodeHTML(name);
    formattedPlayer = cleanPlayerName(formattedPlayer, '_');
    return (
      <TeamLabel
        isPlayer
        image={`${playersURL}${formattedPlayer}_${formattedDate}.png`}
        isSquad
        overflow
        marginRight={0.5}
        justifyContent="right"
      />
    );
  };

  render() {
    const {
      squads, widgetId,
    } = this.props;
    const {
      isMobile,
    } = this.state;
    const squad = squads[widgetId];
    const teamSquad = squad && squad.contents && squad.contents[0]
    && squad.contents[0].squad ? squad.contents[0].squad : [];
    return (
      <SquadWidgetWrapper isMobile={isMobile}>
        {squad && squad.teamName &&
          <Label
            label={`Rosa squadra - ${squad.teamName}`}
            size={1.3}
            weight="bold"
            margin="10px 0 16px"
          />
        }
        <HeaderWrapper className="has-background-primary">
          <Col
            md={1.8}
            sm={1.8}
            style={{
              display: 'flex',
              paddingRight: '0px',
              paddingLeft: '0px',
              justifyContent: 'flex-end',
            }}
          />
          <Col
            md={1}
            sm={1}
            style={{
              display: 'flex',
              paddingRight: '0px',
              paddingLeft: '0',
              justifyContent: 'center',
            }}
          >
            <Label
              label="N."
              size={0.9}
              weight="bold"
              color="white"
            />
          </Col>
          <Col md={7.2} sm={7.2} style={{ display: 'flex', paddingLeft: '0' }}>
            <Label
              label="Nome"
              size={0.9}
              weight="bold"
              color="white"
            />
          </Col>
          <Col
            md={2}
            sm={2}
            style={{ display: 'flex', justifyContent: 'center' }}
          >
            <Label
              label="Pos."
              size={0.9}
              weight="bold"
              color="white"
            />
          </Col>
        </HeaderWrapper>
        {teamSquad && teamSquad.map((player, index) => (
          <RowWrapper key={index}>
            <Col
              md={1.8}
              sm={1.8}
              style={{
                display: 'flex', paddingRight: '0px', paddingLeft: '0px', justifyContent: 'flex-end',
              }}
            >
              {this.renderPlayerPic(player.playerName, player.playerBirthDate)}
            </Col>
            <Col
              md={1}
              sm={1}
              style={{
                display: 'flex', paddingRight: '0px', paddingLeft: '0', justifyContent: 'center',
              }}
            >
              <Label
                label={player.playerJersey === 'Unknown' ? '' : player.playerJersey}
                isTitleNarrowMedium
                margin="0 6px 0 0"
                size={0.9}
              />
            </Col>
            <Col
              md={7.2}
              sm={7.2}
              style={{
                  display: 'flex', justifyContent: 'flex-start', paddingLeft: '0px', overflow: 'visible',
              }}
            >
              <Label
                label={entities.decodeHTML(player.playerKnownName ? player.playerKnownName : player.playerName)}
                size={0.9}
              />
            </Col>
            <Col md={2} sm={2} style={{ display: 'flex', justifyContent: 'center' }}>
              <Label
                label={player.playerRole.substring(0, 1)}
                size={0.9}
              />
            </Col>
          </RowWrapper>
        ))}
      </SquadWidgetWrapper>
    );
  }
}

SquadWidgetGazzanet.propTypes = {
  actions: PropTypes.any,
  squads: PropTypes.any,
  teamId: PropTypes.any,
  sportId: PropTypes.any,
  competitionId: PropTypes.any,
  widgetId: PropTypes.any,
};

export default connect(
  state => ({
    dictionary: state.dictionaryReducer.dictionary,
    squads: state.topScorersReducer.squads,
  }),
  dispatch => ({
    actions: {
      initDictionary: () =>
        dispatch({ type: types.INIT_DICTIONARY }),
      getLineup: (sportId, teamId, competitionId, widgetId) =>
        dispatch({
          type: types.GET_SQUAD_REQUEST, sportId, teamId, competitionId, widgetId,
        }),
    },
  }),
)(SquadWidgetGazzanet);



// WEBPACK FOOTER //
// ./src/containers/GazzanetWidgets/SquadWidgetGazzanet/index.js